// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { TypographyPresentationProps } from "@insite/mobius/Typography";
import { productPriceStyles } from "@sc/Overrides/Components/ProductPrice";
import AlertWarning from "@sc/XDL/Icons/AlertWarning";
import { css } from "styled-components";

const unitOfMeasureText: TypographyPresentationProps = {
    size: 12,
    lineHeight: "13px",
    color: "common.ui7",
    css: css`
        white-space: nowrap;
    `,
};

productPriceStyles.wrapper = {
    css: css`
        display: flex;
        align-items: center;
    `,
};

productPriceStyles.failedToLoadPricingWrapper = {
    css: css`
        display: flex;
        align-items: center;
    `,
};

productPriceStyles.price = {
    priceText: {
        ...productPriceStyles.price?.priceText,
        size: 18,
        lineHeight: "24px",
    },
    unitOfMeasure: {
        unitOfMeasureText,
    },
};
productPriceStyles.quoteMessage = {
    tooltip: {
        iconProps: {
            color: "warning",
            src: AlertWarning,
            size: 14,
            css: css`
                opacity: 0.66;
            `,
        },
    },
    text: {
        color: "danger",
        size: 16,
        weight: "bold",
        lineHeight: "22px",
    },
};

productPriceStyles.unitOfMeasure = {
    unitOfMeasureText,
};
productPriceStyles.failedToLoadPricingIcon = {
    color: "warning",
    size: 14,
    src: AlertWarning,
    css: css`
        margin-left: 4px;
        opacity: 0.66;
    `,
};

productPriceStyles.priceLabelText = {
    lineHeight: "14px",
    weight: "normal",
    transform: "capitalize",
    css: css`
        font-size: 12px;
    `,
};

productPriceStyles.qtyBreakPriceStyles = {
    size: 12,
    weight: "bold",
    lineHeight: "14px",
    css: css`
        text-decoration: line-through;
        margin-bottom: 5px;
    `,
};

productPriceStyles.noPrice = {
    size: 16,
    weight: "bold",
    lineHeight: "22px",
    color: "primary.main",
};
